import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

//Modulos

import { AppRoutingModule } from './app-routing.module';
import { PagesModule } from './pages/pages.module';
import { AuthModule } from './auth/auth.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { ToastrModule } from 'ngx-toastr'


import { AppComponent } from './app.component';
import { NotfoundComponent } from './notfound/notfound.component';
import { Ng9RutModule } from 'ng9-rut';
import { CloudsignersuccessComponent } from './handler/cloudsignersuccess/cloudsignersuccess.component';
import { CloudsignerfailedComponent } from './handler/cloudsignerfailed/cloudsignerfailed.component';
import { TransbanksuccessComponent } from './handler/transbanksuccess/transbanksuccess.component';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';


@NgModule({
  declarations: [
    AppComponent,
    NotfoundComponent,
    CloudsignersuccessComponent,
    CloudsignerfailedComponent,
    TransbanksuccessComponent,
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    PagesModule,
    AuthModule,
    FormsModule,
    Ng9RutModule,
    BrowserAnimationsModule,
    NgxMatSelectSearchModule,
    MatFormFieldModule,
    MatSelectModule,
    ToastrModule.forRoot(
      {
      }
    )
  ],

  bootstrap: [AppComponent]
})
export class AppModule { }
